// extracted by mini-css-extract-plugin
export default {"summary":"OrderSummary_summary","title":"OrderSummary_title","subTitle":"OrderSummary_subTitle","disclaimer":"OrderSummary_disclaimer"};